import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import FormRow from 'Components/FormRow';
import InputHandler from 'Components/InputHandler';

const PelvisForm = ({ formData, disabledFields = [] }: IOwnProps): React.JSX.Element => (
  <React.Fragment>
    <FormRow title="general.date">
      <InputHandler
        type="PartialDate"
        editing={!disabledFields.includes('date')}
        name="date"
        formData={formData}
        dateDefault="now"
        isNotCancellable={true}
      />
    </FormRow>
    <FormRow title="imaging.hipSubluxationLuxation">
      <InputHandler
        type="Radio"
        editing={true}
        name="hipSubluxationLuxation"
        formData={formData}
        options={['yes', 'no', 'unknown']}
        optionFormatter={(name: string | number): React.JSX.Element => <FormattedMessage id={`general.${name}`} />}
      />
    </FormRow>
    {formData.document.hipSubluxationLuxation === 'yes' && (
      <FormRow title="imaging.migrationPercentage">
        <InputHandler
          type="NumberField"
          editing={true}
          name="migrationPercentage"
          formData={formData}
          placeholder="imaging.migrationPercentagePlaceholder"
          width={10.4}
          height={3}
          maxLength={5}
          min={0}
          max={1000}
          precision={2}
        />
      </FormRow>
    )}
  </React.Fragment>
);

interface IOwnProps {
  formData: IFormData<IDocumentWithTypeV2<'pelvis'>>;
  disabledFields?: string[];
}

export default PelvisForm;
